import { useEffect, useState } from 'react';
import { listarDatasOcorrenciaAtivo } from '~/Services/Service';

// W-0489 / T13 — Hook de fetch de datas para par titulo+ativo (Tab Por Titulo, nivel 3).
// LICOES Ciclo 9 L3: pattern `let ativo = true`.

const extrairMsg = (err, fallback) =>
  (err && err.message) ? err.message : fallback;

const useDatasPorAtivoTitulo = (titulo, codigoAtivo, dataInicio) => {
  const [estado, setEstado] = useState({
    loading: false,
    items: [],
    erro: null,
  });

  useEffect(() => {
    if (titulo == null || codigoAtivo == null) {
      setEstado({ loading: false, items: [], erro: null });
      return undefined;
    }
    let ativo = true;
    setEstado((prev) => ({ ...prev, loading: true, erro: null }));
    listarDatasOcorrenciaAtivo(titulo, codigoAtivo, dataInicio)
      .then((res) => {
        if (!ativo) return;
        setEstado({ loading: false, items: Array.isArray(res) ? res : [], erro: null });
      })
      .catch((err) => {
        if (!ativo) return;
        setEstado({
          loading: false,
          items: [],
          erro: extrairMsg(err, 'Erro ao carregar datas.'),
        });
      });
    return () => {
      ativo = false;
    };
  }, [titulo, codigoAtivo, dataInicio]);

  return estado;
};

export default useDatasPorAtivoTitulo;
